import React from 'react';
import { format } from 'date-fns';
import { reportMapper } from '../../utils/helper';
import { FileIcon, SpinnerIcon } from '../../icons';
import { useDownloadReports } from '../../hooks/react-query/useUserData';
import { exportToExcel } from '../../utils/exports';
import { toast } from '../ui/Toast/useToast';

const ReportComponent = ({ listKey, date }) => {
  const { mutate, isLoading } = useDownloadReports();

  const properties = reportMapper(listKey);

  const handleDownloadClick = () => {
    const payload = {
      date_from: format(new Date(date.from), 'dd-MM-yyyy'),
      date_to: format(new Date(date.to), 'dd-MM-yyyy'),
      fields: ['all'],
      report_type: listKey,
    };
    mutate(payload, {
      onSuccess: (response) => {
        if (response?.exceptions) {
          if (response.exceptions?.length > 0) {
            const errMsg = response.exceptions?.slice(-1);
            toast({
              variant: 'destructive',
              description: errMsg || 'Παρουσιάστηκε κάποιο πρόβλημα',
            });
            return;
          }
        }
        if (response.data) {
          if (response.data.rows) {
            let reportType = response.data.reportType;
            const [header, ...restData] = response.data.rows;
            const xlsData = [];
            restData.forEach((row) => {
              const temp = {};
              Object.keys(row).forEach((itm) => {
                temp[header[itm]] = row[itm];
              });
              xlsData.push(temp);
            });
            exportToExcel(xlsData, reportType);
          }
        } else {
          toast({
            variant: 'destructive',
            description: 'Παρουσιάστηκε κάποιο πρόβλημα',
          });
        }
      },
    });
  };

  return (
    <li className="flex w-full bg-whiteTransparent backdrop-blur-ice rounded-[12px] p-6 flex-col justify-between min-h-[314px]">
      <div className="flex flex-col gap-4 max-lg:pb-2">
        <FileIcon width={80} height={80} className="stroke-fadedgrey" />
        <h3>{properties.label}</h3>
        <p className="text-body">{properties.title}</p>
      </div>
      <div className="flex lg:justify-end">
        <button
          type="button"
          className="max-lg:w-full btn-primary text-primary-button flex gap-2 items-center justify-center"
          onClick={handleDownloadClick}
        >
          {isLoading && <SpinnerIcon />}
          Λήψη αναφοράς
        </button>
      </div>
    </li>
  );
};

export default ReportComponent;
